import { RuleObject } from "antd/es/form";
import { validatePhone } from "../../../utils/validators";

const emailRegex = /^[^.\s@:](?:[^\s@:]*[^\s@:.])?@[^.\s@]+(?:\.[^.\s@]+)*$/;

const passwordRegex =
    /^(?!.*\s)(?:(?=.*[A-Z])(?=.*[a-z])|(?=.*[A-Z])(?=.*\d)|(?=.*[A-Z])(?=.*[!@#$%^&()])|(?=.*[a-z])(?=.*\d)|(?=.*[a-z])(?=.*[!@#$%^&()])|(?=.*\d)(?=.*[!@#$%^&()]))[A-Za-z0-9!@#$%^&()]{6,20}$/;

export function validateEmail(email: string): boolean {
    return emailRegex.test(email);
}

export function validatePassword(password: string): boolean {
    return passwordRegex.test(password);
}

export function phoneValidator(t: any): RuleObject {
    return {
        validator: (_, value): Promise<void> => {
            if (validatePhone(value)) {
                return Promise.resolve();
            }

            return Promise.reject(t("enter-phone-invalid"));
        },
    };
}

export function emailValidator(t: any): RuleObject {
    return {
        validator: (_, value): Promise<void> => {
            if (validateEmail(value)) {
                return Promise.resolve();
            }

            return Promise.reject(t("enter-email-invalid"));
        },
    };
}

export function accountValidator(t: any): RuleObject {
    return {
        validator: (_, value): Promise<void> => {
            if (!value) {
                return Promise.reject(t("login-page.enter-account-empty"));
            }
            if (validateEmail(value) || validatePhone(value)) {
                return Promise.resolve();
            }
            return Promise.reject(t("login-page.enter-account-invalid"));
        },
    };
}
export function passwordValidator(t: any): RuleObject {
    return {
        validator: (_, value): Promise<void> => {
            if (validatePassword(value)) {
                return Promise.resolve();
            }

            return Promise.reject(t("login-page.password-rule"));
        },
    };
}
